<template>
  <li>
    <div class="homework__item" :class="rightDates ? 'active' : 'passive'">
      <div class="homework__date"><span class="ico-calendar" uk-tooltip="Дата"></span> <span>{{ date }}</span></div>
      <ul class="homework__trains">
        <li v-for="item in items" :key="item.id" class="homework__train" :class="item.is_done == 1 ? 'homework__train--complete' : ''">
          <div class="homework__base">
            <div class="homework__wrap">
              <div class="homework__content">
                <div class="homework__title">{{ item.homework.trainer ? item.homework.trainer.title : item.homework.params.title }}</div>
                <div class="homework__params">
                  <div v-if="item.homework.trainer">
                    <small>Выполнено:</small>
                    {{ item.total }} из {{ item.homework.qnt }},
                    <small>Статус:</small>
                    {{ item.status }}
                  </div>
                </div>
              </div>
              <div class="homework__button">
                <!--<button @click="beginHomework(item)" class="uk-button" :disabled="isDisabled(item)">{{ isDisabled(item) ? 'Сделано' : buttonText(item) }}</button>-->
                <button v-if="item.homework.trainer" @click="checkStudent(item)" :disabled="isDisabled(item)">
                  <span></span></button>
                <div v-else class="homework__buttons">
                  <button class="qst" @click="showAlert(item)" uk-tooltip="Прочитать задание">?</button>
                  <button @click="showBookReadAnswer(item)" uk-tooltip="Выполнить задание" :disabled="isBookDisabled(item)">
                    <span></span></button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "homeworks-item",
  data() {
    return {
      dates: ''
    }
  },
  inject: ['http'],
  props: {
    items: '',
    date: ''
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    currentDate() {
      let date = moment(this.date, 'DD-MM-YYYY');
      return moment().isSame(date, 'day');
    },
    lastDate() {
      let date = moment(this.date, 'DD-MM-YYYY');
      return moment().subtract(1, 'days').isSame(date, 'day');
    },
    rightDates() {
      let date = moment(this.date, 'DD-MM-YYYY');
      if (moment().isSame(date, 'day') || moment().subtract(1, 'days').isSame(date, 'day')) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions({
        getHomework: 'student/getHomework'
      }),
    /*makeDates() {
      console.log('makeDates', this.item);
      let dates = _.groupBy(this.item.homeworkstudent, 'date');
      this.dates = dates;
    },*/
    showAlert(item) {
      UIkit.modal.dialog(item.homework.params.desc);
    },
    checkStudent(item) {
      this.http.post('onCheckStudent', { homework_id: item.id }).then(res => {
        let auth = res.data.auth_status
        let homework = res.data.homework_status

        if (!auth) {
          location.reload();
          return false
        } else if (!homework) {
          swal('Ошибка', 'Задание не найдено', 'warning')
          this.getHomework(this.user.id)
          return false
        } else {
          this.beginHomework(item)
        }
      })
    },
    async showBookReadAnswer(item) {
      let modal = UIkit.modal.prompt('Напишите название книги которую читали:', '');
      modal.dialog.$el.classList.add("prompt-modal");
      modal.dialog.$el.querySelector(".uk-input").placeholder = 'Название книги';
      modal.dialog.$el.querySelector(".uk-button-primary").innerHTML = 'Ответить';
      modal.dialog.$el.querySelector(".uk-modal-close").innerHTML = 'Отмена';
      let name = await modal.then((name) => {
        return name;
      });

      if (!name) return;

      this.saveHomeworkResult(item, name);

    },

    saveHomeworkResult(item, desc) {
      console.log(item, desc);
      item.desc = desc;
      item.is_done = 1;
      item.status = 'Выполнено';
      this.http.post('onUpdateBookHomework', item).then((res) => {
        console.log(res.data);
      });
    },

    isDisabled(item) {
      if ((item.total >= item.homework.qnt) || !this.rightDates) {
        return true;
      }
      return false;
    },

    isBookDisabled(item) {
      if (item.is_done === 1) return true;
    },

    buttonText(item) {
      if (item.total > 0) {
        return 'Продолжить'
      }
      return 'Начать';
    },
    beginHomework(item) {
      //console.log('Начинай, блеать!', item);
      let component = item.homework.trainer.component;
      let params = item.homework.params;
      let qnt = item.homework.qnt;
      let date = item.date
      params.start = true;
      if (component == 'mnemo') {
        params.start = false;
        params.get_ready = true;
      }
      let data = {
        'train': component + '_params',
        'params': params
      }
      this.$store.commit('train/changeParams', data);
      this.$router.push({
        name: 'trainer',
        params: { component: component, params, isHomework: true, homework_id: item.id, qnt: qnt, total: item.total, date: date }
      });
    }
  },
  mounted() {
    // this.makeDates();
  }
}
</script>